/*
 *
 * Hedera Stablecoin SDK
 *
 * Copyright (C) 2023 Hedera Hashgraph, LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Injectable from '../../core/Injectable.js';
import ContractId from '../../domain/context/contract/ContractId.js';
import { CommandBus } from '../../core/command/CommandBus.js';
import { handleValidation } from './Common.js';
import { QueryBus } from '../../core/query/QueryBus.js';
import { LogError } from '../../core/decorator/LogErrorDecorator.js';
import GetTokenManagerListRequest from './request/GetTokenManagerListRequest.js';
import { GetTokenManagerListQuery } from '../../app/usecase/query/factory/getTokenManagerList/GetTokenManagerListQuery.js';
import { MirrorNodeAdapter } from '../../port/out/mirror/MirrorNodeAdapter.js';
class FactoryInPort {
    constructor(commandBus = Injectable.resolve(CommandBus), queryBus = Injectable.resolve(QueryBus), mirrorNode = Injectable.resolve(MirrorNodeAdapter)) {
        this.commandBus = commandBus;
        this.queryBus = queryBus;
        this.mirrorNode = mirrorNode;
    }
    async getHederaTokenManagerList(request) {
        handleValidation('GetTokenManagerListRequest', request);
        const factoryId = (await this.mirrorNode.getContractInfo(request.factoryId)).id;
        const res = await this.queryBus.execute(new GetTokenManagerListQuery(new ContractId(factoryId)));
        return res.payload;
    }
}
__decorate([
    LogError,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [GetTokenManagerListRequest]),
    __metadata("design:returntype", Promise)
], FactoryInPort.prototype, "getHederaTokenManagerList", null);
const Factory = new FactoryInPort();
export default Factory;
